import { errorAction, successfulAction } from '@shared/actions';
import addItem from '@services/cart/addItem';
import trackCartStarted from '@conversion/tracking/actions/trackCartStarted';
import trackAddCartClicked from '@conversion/tracking/actions/trackAddCartClicked';
import getCart from '@core/reducers/cart/selectors/getCart';
import getAddLineFeaturedProduct from '@core/reducers/cart/selectors/getAddLineFeaturedProduct';
import { ADD_LINE } from '@core/reducers/cart/actionTypes';

const type = ADD_LINE;
const errorMessage =
  'Ocurrió un error al agregar el producto. Por favor intente nuevamente.';

const addCartItem = ({ line, origin }) => async (dispatch, getState, axios) => {
  try {
    const state = getState();
    const cart = getCart(state);
    const { success, data, error } = await addItem({
      axios,
      line,
      cartId: cart.guid,
    });

    if (success) {
      dispatch(
        successfulAction({
          type,
          payload: {
            cart: data,
            featuredProduct: getAddLineFeaturedProduct(state),
          },
        }),
      );

      if (!cart.items || cart.items.length === 0) {
        dispatch(trackCartStarted());
      }
      dispatch(trackAddCartClicked(origin));
    } else {
      dispatch(errorAction({ type, error, errorMessage }));
    }
  } catch (error) {
    dispatch(errorAction({ type, error, errorMessage }));
  }
};

export default addCartItem;
